import merge from "lodash/merge";

import commonLocales from "@/locales/en/common.json";
import errorsLocales from "@/locales/en/errors.json";
import forumLocales from "@/locales/en/forum.json";
import brainstormersLocales from "@/locales/en/brainstormers.json";
import budgetLocales from "@/locales/en/budget.json";
import loginLocales from "@/locales/en/login.json";
import profileLocales from "@/locales/en/profile.json";
import questionsLocales from "@/locales/en/questions.json";
import quickPollLocales from "@/locales/en/quick-poll.json";
import registerLocales from "@/locales/en/register.json";
import surveyLocales from "@/locales/en/survey.json";
import usersLocales from "@/locales/en/users.json";
import projectFinderLocales from "@/locales/en/project-finder.json";
import participantHeaderLocales from "@/locales/en/participant-header.json";
import placesLocales from "@/locales/en/places.json";
import toolsLocales from "@/locales/en/tools.json";
import profileGateLocales from "@/locales/en/profile-gate.json";

import esLocales from "@/locales/es/es.json";
import cyLocales from "@/locales/cy/cy.json";
import frCALocales from "@/locales/fr-CA/fr-CA.json";

export const EOLocales = [
  {
    language: "en",
    messages: merge(
      commonLocales,
      errorsLocales,
      forumLocales,
      brainstormersLocales,
      budgetLocales,
      loginLocales,
      profileLocales,
      questionsLocales,
      quickPollLocales,
      registerLocales,
      surveyLocales,
      usersLocales,
      projectFinderLocales,
      participantHeaderLocales,
      placesLocales,
      toolsLocales,
      profileGateLocales
    )
  },
  {
    language: "en-US",
    messages: merge(
      commonLocales,
      errorsLocales,
      forumLocales,
      brainstormersLocales,
      budgetLocales,
      loginLocales,
      profileLocales,
      questionsLocales,
      quickPollLocales,
      registerLocales,
      surveyLocales,
      usersLocales,
      projectFinderLocales,
      participantHeaderLocales,
      placesLocales,
      toolsLocales,
      profileGateLocales
    )
  },
  {
    language: "fr-CA",
    messages: frCALocales
  },
  {
    language: "es",
    messages: esLocales
  },
  {
    language: "cy",
    messages: cyLocales
  }
];
